import {Injectable} from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate, GuardsCheckEnd, GuardsCheckStart,
  NavigationEnd, NavigationStart,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import * as firebase from 'firebase';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {filter, map, mergeMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private authService: AuthService, private _route: ActivatedRoute,
              private activatedRoute: ActivatedRoute) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise(
      (resolve, reject) => {
        firebase.auth().onAuthStateChanged(
          async (user) => {
            if (user) {
              await this.authService.getAuthorisation(user);
              resolve(this.authService.isAuth);
            } else {
              await this.router.navigate(['/authentication', 'login']);
              resolve(false);
            }
          },
          (error) => {
            reject(error);
          }
        );
      }
    );
  }
}
